<odx-inline-message i18n="@@projectDetails.tabBar.floorplans.notOptimizedForTablet">
  Die Navinta Software ist aktuell für dieses Gerät nicht optimiert. Es wird empfohlen auf ein Desktop- oder Laptopgerät zu
  wechseln.
</odx-inline-message>
